import { Message } from "../model/Message";

class LocalStorage {
  private GetFromLocal = (key: string, defaultValue: string = '') =>
    localStorage.getItem(key) || defaultValue

  private GetFromSessionThenLocal = (key: string, defaultValue: string = '') =>
    sessionStorage.getItem(key) || this.GetFromLocal(key, defaultValue)

  private SetToLocal(key: string, value: string) {
    localStorage.setItem(key, value)
  }

  private SetToSessionAndLocal(key: string, value: string) {
    sessionStorage.setItem(key, value)
    this.SetToLocal(key, value)
  }

  private selectedSiteKey = 'selected-site'
  public GetSelectedSite = () => this.GetFromSessionThenLocal(this.selectedSiteKey, 'no_site')
  public SetSelectedSite = (site: string) => this.SetToSessionAndLocal(this.selectedSiteKey, site)

  private siteModeKey = 'site-mode'
  public GetSiteMode = () => this.GetFromSessionThenLocal(this.siteModeKey, 'downtime')
  public SetSiteMode = (mode: string) => this.SetToSessionAndLocal(this.siteModeKey, mode)

  private messagesKey = 'messages'
  public GetMessages = () => (JSON.parse(this.GetFromLocal(this.messagesKey, JSON.stringify([]))) as any[])
    .map(m => new Message(m.message, m.detail, m.channel, new Date(m.timestamp + (m.timestamp.endsWith("Z") ? "" : "Z")), m.dismissed));
  public SetMessages = (messages: Message[]) => this.SetToLocal(this.messagesKey, JSON.stringify(messages));
}

export const SiteStoredSettings = new LocalStorage()
